// pages/Profile.js
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import axios from "axios";

const Profile = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.user_id;

  const fetchProfile = async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/api/user/${userId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      if (res.data.status === "success") {
        setUserData(res.data.data);
        form.setFieldsValue({
          username: res.data.data.username,
          email: res.data.data.email
        });
      }
    } catch (err) {
      console.error("Failed to fetch profile:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleUpdate = async (values) => {
    setLoading(true);
    try {
      await axios.put(`${BASE_URL}/api/user/${userId}`, values, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      message.success("Profile updated successfully");
      fetchProfile();
    } catch (err) {
      message.error("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  if (!userData) return <p>Loading...</p>;

  return (
    <Card title="My Profile">
      <Form form={form} layout="vertical" onFinish={handleUpdate}>
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Please input your username" }]}
        >
          <Input placeholder="Username" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please input your email" },
            { type: "email", message: "Please enter a valid email" }
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>

        {/* <Form.Item
          label="Password"
          name="password"
          rules={[{ min: 6, message: "Password must be at least 6 characters" }]}
        >
          <Input.Password placeholder="Leave blank if not changing" />
        </Form.Item> */}

            <Form.Item style={{ textAlign: 'right' }}>
                <Button
                    htmlType="submit"
                    style={{
                        backgroundColor: '#ec4899',
                        borderColor: '#ec4899',
                        color: '#fff',
                    }}
                >
                    Update
                </Button>
            </Form.Item>
      </Form>
    </Card>
  );
};

export default Profile;
